<template>
  <v-container fluid style="padding: 0">
    <v-dialog v-model="dialogIndex" max-width="1200">
      <v-card>
        <v-card-text>
          <!-- Conteúdo do card -->
          <v-tabs color="primary" dark slider-color="white">
            <v-tab v-if="$auth.user().acesso_interno == 'dev'">Atualizações Matriz</v-tab>
            <v-tab-item v-if="$auth.user().acesso_interno == 'dev'">
              <atualizacao-matriz ref="atualizacaoMatriz"></atualizacao-matriz>
            </v-tab-item>
            <v-tab>Atualizações</v-tab>
            <v-tab-item>
              <atualizacao-user></atualizacao-user>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <!-- Botão "Fechar" dentro das actions do card -->
          <v-btn color="primary" @click="() => (dialogIndex = false)">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn flat icon dark @click="abrirDialog">
      <v-badge color="purple" left overlap>
        <template v-slot:badge>
          {{ quantidade_atualizacao_nao_visualizada }}
        </template>
        <v-icon dark>notifications</v-icon>
      </v-badge>
    </v-btn>
  </v-container>
</template>

<style scoped>
.custom-v-card-text {
  padding: 5px;
  border: 1px solid #2e7d32;
  border-radius: 5px;
  margin-bottom: 5px;
}
</style>

<script>
import AtualizacaoMatriz from "./AtualizacaoMatriz.vue";
import AtualizacaoUser from "./AtualizacaoUser.vue";

export default {
  components: { AtualizacaoMatriz, AtualizacaoUser },
  data() {
    return {
      entity: "atualizacao",
      dialogIndex: false,
      quantidade_atualizacao_nao_visualizada: "",
    };
  },
  methods: {
    abrirDialog() {
      this.$refs.atualizacaoMatriz.$emit("dialog_opened");
      this.dialogIndex = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/crud/Atualizacao.vue